import useClientSuspenseQuery from './useClientSuspenseQuery';

export type { ClientSuspenseQueryOptions } from './useClientSuspenseQuery';

export default useClientSuspenseQuery;
